<template>
    <div class="d-inline">
        <button type="button" class="btn btn-sm shadow-sm btn-outline-secondary" data-toggle="modal"
                data-target="#release-modal">
            {{ buttonText }}
            <span v-if="release.released">(Aktiv)</span>
        </button>
        <div class="modal fade" id="release-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ title }}
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-group">
                            <label>
                                <i class="fas fa-info-circle text-muted"
                                   style=""
                                   data-toggle="tooltip"
                                   data-placement="top"
                                   title="Welchen Herstellern soll diese Auswertung sichtbar gemacht werden? (Mehrfachauswahl)"></i>
                                Anbieter
                            </label>
                            <div v-if="!release.released">
                                <custom-select v-model="release.manufacturerIds"
                                               :settings="anbieterSettings"/>
                                <div class="form-check mt-1">
                                    <input class="form-check-input" type="checkbox" value="" id="release-no-bga"
                                           v-model="release.noBga">
                                    <label class="form-check-label" for="release-no-bga">
                                        Freigabe ohne BGA Daten
                                    </label>
                                </div>
                            </div>
                            <div v-else>
                                Freigegeben für:
                                <ul class="mt-2">
                                    <li v-for="manufacturer in manufacturerNames">{{ manufacturer }}</li>
                                </ul>
                                <span class="text-muted" v-if="release.noBga">BGA Daten wurden nicht übertragen.</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-primary" @click="doRelease" v-if="!release.released">
                                Freigeben
                            </button>
                            <button type="button" class="btn btn-warning" @click="removeRelease" v-else>
                                Freigabe aufheben
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Schließen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: true
        },
        releaseUrl: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            default: 'DIREKTplus Freigabe'
        },
        title: {
            type: String,
            default: 'DIREKTplus Freigabe verwalten'
        }
    },
    data() {
        return {
            release: {
                released: false,
                manufacturerIds: [],
                noBga: true
            },
            manufacturers: {},
            anbieterSettings: {
                ajax: {
                    url: '/select/anbieter',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [','],
                width: '100%',
            },
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            axios.get(this.releaseUrl).then((res) => {
                this.release = res.data.release;
                this.manufacturers = res.data.manufacturers;
            });
        },
        doRelease() {
            axios.post(this.releaseUrl, {
                _token: this.token,
                release: {
                    ...this.release,
                    released: true
                },
            }).catch(() => {
                alert("Fehler");
            }).finally(() => {
                this.fetch();
            });
        },
        removeRelease() {
            if (window.confirm('Sicher?')) {
                axios.post(this.releaseUrl, {
                    _token: this.token,
                    release: {
                        ...this.release,
                        released: false
                    },
                }).catch(() => {
                    alert("Fehler");
                }).finally(() => {
                    this.fetch();
                });
            }
        },
    },
    computed: {
        manufacturerNames() {
            return this.release.manufacturerIds.map((id) => {
                const name = this.manufacturers[id] || '';

                return id + ': ' + name;
            });
        }
    }
}
</script>

<style scoped>

</style>
